import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { setCookie } from "@utils/localStorageUtil";
import { ls_permissionList, ls_permissionList_new } from "@/dataBase/localStorageKeys";
import { getUserInfo, getUserInfoNew, getBId, getOrgInfo, getComtyId, getComtyIdNew, getComtyInfoNew, setBId, setComtyId, setComtyIdNew, setComtyIdToken, setComtyInfo, setComtyInfoNew, setUserInfo, setUserInfoNew, setOrgInfo, getToken, getTokenNew, setIsAuth, getIsAuth } from "@/utils/userStorage";
import authCodeMap from "@/dataBase/authCodeMap";
import service from "@/commonService/index";
import { sortTree, shakeTree, allChild, deleteNode } from "@/utils/commonUtil";
import commonService from "@/commonService";
import { walkArray } from "@/utils/commonUtil";
// import { ActionContext } from "vuex";
const token = getToken();
const tokenNew = getTokenNew();
const userInfo = token ? getUserInfo() || "" : "";
const userInfoNew = tokenNew ? getUserInfoNew() || "" : "";
// const comtyInfo = getCookie(ls_comtyInfo);
const bId = token ? getBId() || "" : "";
const orgInfo = token ? getOrgInfo() || "" : "";
const comtyId = token ? getComtyId() || "" : "";
const comtyIdNew = tokenNew ? getComtyIdNew() || "" : "";
const isHaveAuth = token ? getIsAuth() || null : null;
function controlleMeau(npermission, state) {
  // 如果不是在白名单的社区id，在侧边栏不展示身高测评,白名单用户才可以看见身高测评
  // console.error(process.env.VUE_APP_COMTY_ID, "...process.env.VUE_APP_COMTY_ID..");
  let whiteList = process.env.VUE_APP_COMTY_ID.indexOf("|") > -1 ? process.env.VUE_APP_COMTY_ID.split("|") : [process.env.VUE_APP_COMTY_ID]; // [process.env.VUE_APP_COMTY_ID];
  whiteList = whiteList.map(item => item.trim());
  console.warn(whiteList, ".whiteList..", state.comtyId);
  if (!whiteList.includes(state.comtyId)) {
    deleteNode(npermission, listItem => listItem.permissionFlag === authCodeMap.operationTools_measurementHeight);
  }
}
function setAreaOptions(areaOptions) {
  walkArray(areaOptions, item => {
    if (item.list.length === 0) {
      item.list = null;
    }
    if (item.list && item.list.length > 0) {
      setAreaOptions(item.list);
    }
  });
}
// mutationTypes
export const SET_ADVERT_DATAS = "setAdvertDatas";
const main = {
  state: {
    userInfo: userInfo ? userInfo : {},
    orgInfo: orgInfo ? orgInfo : {},
    comtyId: comtyId ? comtyId : "",
    isEverSetStateGeneService: 0,
    comtyInfo: {
      communityId: "",
      auditStatus: "",
      annualStatus: "",
      expireStatus: "",
      expireSource: ""
    },
    bId: bId || "",
    comtyConfig: {
      settledAudit: ""
    },
    permissionList: "",
    currentRouteName: "",
    messageNumber: -1,
    messageNumberNew: -1,
    pagePermissionList: "",
    advertGroup: [],
    isOrgAuth: isHaveAuth,
    version: "v1",
    comtyIdNew: comtyIdNew ? comtyIdNew : "",
    comtyInfoNew: getComtyInfoNew() || {
      communityId: "",
      auditStatus: "",
      annualStatus: "",
      expireStatus: "",
      expireSource: ""
    },
    permissionListNew: "",
    pagePermissionListNew: "",
    userInfoNew: userInfoNew ? userInfoNew : {},
    comtyIdToken: "",
    isBudgetSystem: null,
    tabNum: {},
    searchItem_Inited: false,
    searchItem_placeCode: {
      label: "所在地区：",
      key: "placeCode",
      type: "cascader",
      placeHolder: "全部",
      clearable: true,
      cascaderOptions: [],
      size: "small",
      props: {
        children: "list",
        label: "dictValue",
        value: "dictCode",
        checkStrictly: true
      },
      style: {
        width: "220px"
      }
    },
    isBudgetHealthProjectAtivitySystemPermission: null
  },
  getters: {
    isLogin: state => {
      return !!(state.userInfo && state.userInfo.id);
    }
  },
  mutations: {
    SET_isBudgetSystem(state, isBudgetSystem) {
      state.isBudgetSystem = isBudgetSystem;
    },
    SET_isBudgetHealthProjectAtivitySystemPermission(state, isBudgetHealthProjectAtivitySystemPermission) {
      state.isBudgetHealthProjectAtivitySystemPermission = isBudgetHealthProjectAtivitySystemPermission;
    },
    SET_searchItem_placeCode(state, searchItem_placeCode) {
      state.searchItem_placeCode = searchItem_placeCode;
    },
    searchItem_Inited(state, searchItem_Inited) {
      state.searchItem_Inited = searchItem_Inited;
    },
    SET_ORG_AUTH(state, isOrgAuth) {
      setIsAuth(isOrgAuth);
      state.isOrgAuth = isOrgAuth;
    },
    SET_PagePermissionList(state, pagePermissionList) {
      state.pagePermissionList = pagePermissionList;
    },
    SET_PagePermissionListNew(state, pagePermissionListNew) {
      state.pagePermissionListNew = pagePermissionListNew;
    },
    SET_CurrentRouteName(state, currentRouteName) {
      state.currentRouteName = currentRouteName;
    },
    SET_USERINFO(state, userInfo) {
      setUserInfo(userInfo);
      state.userInfo = userInfo;
    },
    SET_USERINFONEW(state, userInfo) {
      setUserInfoNew(userInfo);
      state.userInfoNew = userInfo;
    },
    SET_BID(state, bId) {
      setBId(bId);
      state.bId = bId;
    },
    SET_COMTYID(state, comtyId) {
      setComtyId(comtyId);
      state.comtyId = comtyId;
    },
    SET_COMTYIDNEW(state, comtyId) {
      setComtyIdNew(comtyId);
      state.comtyIdNew = comtyId;
    },
    SET_COMTYITOKEN(state, token) {
      setComtyIdToken(token);
      state.comtyIdToken = token;
    },
    SET_ORGINFO(state, orgInfo) {
      setOrgInfo(orgInfo);
      state.orgInfo = orgInfo;
    },
    SET_PERMISSIONLIST(state, permissionList) {
      setCookie(ls_permissionList, permissionList);
      state.permissionList = permissionList;
    },
    SET_PERMISSIONLISTNEW(state, permissionList) {
      setCookie(ls_permissionList_new, permissionList);
      state.permissionListNew = permissionList;
    },
    SET_COMTYINFO(state, comtyinfo) {
      setComtyInfo(comtyinfo);
      state.comtyInfo = comtyinfo;
    },
    SET_COMTYINFONEW(state, comtyinfo) {
      setComtyInfoNew(comtyinfo);
      state.comtyInfoNew = comtyinfo;
    },
    SET_COMTYCONFIG(state, comtyConfig) {
      state.comtyConfig = comtyConfig;
    },
    SET_MESSAGENUMBER(state, messageNumber) {
      // console.log(12312312312312);
      state.messageNumber = messageNumber;
    },
    SET_MESSAGENUMBERNEW(state, messageNumber) {
      // console.log(12312312312312);
      state.messageNumberNew = messageNumber;
    },
    SET_TABNUM(state, tabNum) {
      // console.log(12312312312312);
      state.tabNum = tabNum;
    },
    SET_ADVERT_DATAS: (state, payload) => {
      console.log("111111111");
      state.advertGroup = payload;
    },
    SET_VERSION(state, version) {
      // console.log(12312312312312);
      state.version = version;
    },
    SET_isEverSetStateGeneService(state, version) {
      // console.log(12312312312312);
      state.isEverSetStateGeneService = version;
    }
  },
  actions: {
    async GET_searchItem({
      commit
    }, communityId) {
      const res = await commonService.getDictionaryTree({
        dictParentId: 0,
        dictType: "MAP"
      });
      if (res.code == 200 && res.data) {
        setAreaOptions(res.data);
        commit("SET_searchItem_placeCode", {
          label: "所在地区：",
          key: "placeCode",
          type: "cascader",
          placeHolder: "全部",
          clearable: true,
          cascaderOptions: res.data,
          size: "small",
          props: {
            children: "list",
            label: "dictValue",
            value: "dictCode",
            checkStrictly: true
          },
          style: {
            width: "220px"
          }
        });
      }
      commit("searchItem_Inited", true);
    },
    GET_PagePermissionList({
      commit,
      state
    }) {
      const all = [];
      allChild(state.permissionList, all);
      // console.log("这是全部", all);
      commit("SET_PagePermissionList", all);
    },
    GET_PERMISSIONLIST({
      commit,
      dispatch,
      state
    }) {
      const pp = service.getSysMenuByCommunity({}).then(res => {
        if (res.code == 200 && res.data) {
          let reqPermission = [];
          if (!(state.comtyInfo.enableDoctorCommunity == 1 && state.comtyInfo.enablePatientCommunity == 1) || state.comtyInfo.version === "v2") {
            reqPermission = [{
              menuName: "社区",
              permissionFlag: "top_community",
              sortNo: 1,
              type: "menu",
              children: res.data
            }];
          } else {
            reqPermission = res.data;
          }
          const permission = [];
          sortTree(reqPermission, permission);
          console.log("sortTree", permission);
          const npermission = shakeTree(permission);
          controlleMeau(npermission, state);
          // console.log("controlleMeau", npermission);
          commit("SET_PERMISSIONLIST", npermission);
          dispatch("GET_PagePermissionList");
          // commit(types.SET_PERMISSIONLOADED, true);
        }
      });
      return pp;
    },
    UPDATE_USERINFO({
      commit
    }, token) {
      return service.myinfo({
        token: token
      }).then(res => {
        console.log("UPDATE到了用户信息", res);
        if (res.code == 200 && res.data) {
          const userinfo = res.data;
          // logger.login(userinfo.id as string, {});
          commit("SET_USERINFO", userinfo);
          return userinfo;
        }
      });
    },
    GET_ORGINFO({
      commit
    }) {
      return service.queryOrgDetail({}).then(res => {
        // console.log("UPDATE到了用户信息");
        if (res.code == 200 && res.data) {
          const orginfo = res.data;
          commit("SET_BID", orginfo.id);
          commit("SET_ORGINFO", orginfo);
          service.orgAuthority({
            orgId: orginfo.id
          }).then(result => {
            const isAuth = result.data.authority;
            console.error(result, isAuth, "resultresult");
            commit("SET_ORG_AUTH", isAuth);
          });
          return orginfo;
        }
      });
    },
    UPDATE_COMTYINFO({
      commit
    }, communityId) {
      return service.getCommunityDetail({
        communityId
      }).then(res => {
        if (res.code == 200 && res.data) {
          const comtyinfo = res.data;
          commit("SET_COMTYINFO", comtyinfo);
          return Promise.resolve(res);
        }
      });
    },
    UPDATE_COMTYCONFIG({
      commit
    }, communityId) {
      return service.getCommunityConfig({
        communityId
      }).then(res => {
        if (res.code == 200 && res.data) {
          const comtyConfig = res.data;
          commit("SET_COMTYCONFIG", comtyConfig);
        }
      });
    },
    UPDATE_MESSAGENUMBER({
      commit
    }, communityId) {
      return service.getUnReadMessageNumber({
        communityId
      }).then(res => {
        if (res.code == 200) {
          const messageNumber = res.data;
          commit("SET_MESSAGENUMBER", messageNumber);
        }
      });
    },
    UPDATE_MESSAGENUMBERNEW({
      commit
    }, communityId) {
      return service.findMessageList({
        communityId,
        pageSize: 10,
        pageNum: 1,
        readStatus: false
      }).then(res => {
        if (res.code == 200) {
          const messageNumber = res.data.total || 0;
          commit("SET_MESSAGENUMBERNEW", messageNumber);
        }
      });
    },
    UPDATE_TABNUM({
      commit
    }, communityId) {
      return service.getBubbleData({
        communityId
      }).then(res => {
        if (res.code == 200) {
          const _obj = {};
          for (let i = 0; i < res.data.length; i++) {
            _obj[res.data[i].type] = res.data[i].bubbleNumber;
          }
          commit("SET_TABNUM", _obj);
        }
      });
    },
    UPDATE_VERSION({
      commit
    }, version) {
      commit("SET_VERSION", version);
    },
    async UPDATE_isEverSetStateGeneService({
      commit
    }, communityId) {
      const res = await service.isEverSetStateByCommunityId({
        communityId
      });
      if (res.code == 200 && res.data) {
        const setInfo = res.data;
        commit("SET_isEverSetStateGeneService", setInfo);
        return res;
      }
    },
    async UPDATE_COMTYINFONEW({
      commit
    }, communityId) {
      const res = await service.getCommunityDetail({
        communityId
      });
      if (res.code == 200 && res.data) {
        const comtyinfo = res.data;
        commit("SET_COMTYINFONEW", comtyinfo);
        return res;
      }
    },
    GET_PagePermissionListNEW({
      commit,
      state
    }) {
      const all = [];
      allChild(state.permissionListNew, all);
      // console.log("这是全部", all);
      commit("SET_PagePermissionListNew", all);
    },
    GET_PERMISSIONLISTNEW({
      commit,
      dispatch,
      state
    }) {
      const pp = service.getSysMenuByCommunity({}).then(res => {
        if (res.code == 200 && res.data) {
          let reqPermission = [];
          if (!(state.comtyInfo.enableDoctorCommunity == 1 && state.comtyInfo.enablePatientCommunity == 1) || state.comtyInfo.version === "v2") {
            reqPermission = [{
              menuName: "社区",
              permissionFlag: "top_community",
              sortNo: 1,
              type: "menu",
              children: res.data
            }];
          } else {
            reqPermission = res.data;
          }
          const permission = [];
          sortTree(reqPermission, permission);
          // console.log("sortTree", permission);
          const npermission = shakeTree(permission);
          controlleMeau(npermission, state);
          // console.log("controlleMeau", npermission);
          if (!state.isEverSetStateGeneService) {
            deleteNode(npermission, listItem => listItem.permissionFlag === "gene_service");
          }
          commit("SET_PERMISSIONLISTNEW", npermission);
          dispatch("GET_PagePermissionListNEW");
          // commit(types.SET_PERMISSIONLOADED, true);
        }
      });
      return pp;
    },
    GET_BUDGET_PERMISSIONLISTNEW({
      commit,
      dispatch,
      state
    }) {
      const pp = service.getSysMenuByHealthServiceProject({}).then(res => {
        if (res.code == 200 && res.data) {
          console.log("GET_BUDGET_PERMISSIONLISTNEW", state);
          // dispatch("GET_PERMISSIONLISTNEW");
          let reqPermission = [];
          // const resdata = temPermissions;
          reqPermission = [{
            menuName: "社区",
            permissionFlag: "top_community",
            sortNo: 1,
            type: "menu",
            children: res.data
          }];
          const permission = [];
          sortTree(reqPermission, permission);
          // console.log("sortTree", permission);
          const npermission = shakeTree(permission);
          controlleMeau(npermission, state);
          if (!state.isEverSetStateGeneService) {
            deleteNode(npermission, listItem => listItem.permissionFlag === "gene_service");
          }
          commit("SET_PERMISSIONLISTNEW", npermission);
          dispatch("GET_PagePermissionListNEW");
        }
      });
    }
  }
};
export default main;